import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CmsParagraphComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';

@Component({
    selector: 'app-cookie-policy-paragraph',
    templateUrl: './cookie-policy-paragraph.component.html',
    styleUrl: './cookie-policy-paragraph.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CookiePolicyParagraphComponent {
  public componentData: CmsParagraphComponent;

  constructor(public component: CmsComponentData<CmsParagraphComponent>) { }

  ngOnInit(): void {
    this.component.data$.subscribe((data) => {
      this.componentData = data;
    });
  }
}
